import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import userMobx from '../../../../../../mobx/user'
import { BrandI } from '../../../../../../types-project/Client'

interface AddBrandModalProps {
  onClose: () => void
}

const VOGZ_GRADIENT = 'linear-gradient(45deg, #615AF6, #2A42A7)'

const inputStyle: React.CSSProperties = {
  width: '100%',
  borderRadius: 10,
  border: '1px solid #E2E5F0',
  padding: '10px 12px',
  fontSize: 14,
  outline: 'none',
  background: '#fff',
}

const labelStyle: React.CSSProperties = {
  display: 'block',
  color: '#5b6178',
  fontFamily: 'Hurme-Bold, sans-serif',
  fontSize: 13,
  marginBottom: 6,
}

const isValidUrl = (value: string) => {
  try {
    // eslint-disable-next-line no-new
    new URL(value)
    return true
  } catch {
    return false
  }
}

const AddBrandModal: FC<AddBrandModalProps> = ({ onClose }) => {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [url, setUrl] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const submit = async () => {
    if (name.trim().length < 2) {
      toast.error(t('myprofil:brand-page.validation-name'), { theme: 'colored' })
      return
    }
    if (!isValidUrl(url.trim())) {
      toast.error(t('myprofil:brand-page.validation-url'), { theme: 'colored' })
      return
    }
    setSubmitting(true)
    // createBrand stocke la nouvelle marque en session puis recharge sur le hub,
    // qui la sélectionnera automatiquement.
    await userMobx.createBrand(
      { name: name.trim(), info: { url: url.trim() }, guests: [] } as BrandI<string[]>,
      () => {}
    )
    setSubmitting(false)
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ background: 'rgba(20,24,48,.45)' }}
      onClick={onClose}
    >
      <div
        style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 18, padding: 28, boxShadow: '0 20px 60px rgba(20,24,48,.3)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-5">
          <h3 style={{ color: '#2A42A7', fontFamily: 'Hurme-Black, sans-serif', fontSize: 19 }}>
            {t('myprofil:brand-page.create-brand.title')}
          </h3>
          <button type="button" onClick={onClose} style={{ color: '#9aa0bd', fontSize: 18, cursor: 'pointer' }}>
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <label style={labelStyle}>{t('myprofil:brand-page.create-brand.name')}</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t('myprofil:brand-page.create-brand.name')}
          style={{ ...inputStyle, marginBottom: 16 }}
        />

        <label style={labelStyle}>{t('myprofil:brand-page.create-brand.url')}</label>
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://www.exemple.com"
          style={{ ...inputStyle, marginBottom: 24 }}
        />

        <div className="flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            style={{ padding: '10px 18px', color: '#7a8196', fontFamily: 'Hurme-Bold, sans-serif', fontSize: 14, cursor: 'pointer' }}
          >
            {t('myprofil:brand-page.create-brand.cancel')}
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={submitting}
            style={{
              borderRadius: 10,
              background: VOGZ_GRADIENT,
              color: '#fff',
              fontFamily: 'Hurme-Bold, sans-serif',
              fontSize: 14,
              padding: '10px 22px',
              boxShadow: '0 4px 14px rgba(97,90,246,.3)',
              cursor: submitting ? 'default' : 'pointer',
              opacity: submitting ? 0.6 : 1,
            }}
          >
            {t('myprofil:brand-page.create-brand.submit')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default observer(AddBrandModal)
